import { render, staticRenderFns } from "./QuickActions.vue?vue&type=template&id=24c5bd54&scoped=true&lang=html&"
import script from "./QuickActions.vue?vue&type=script&lang=js&"
export * from "./QuickActions.vue?vue&type=script&lang=js&"
import style0 from "./QuickActions.vue?vue&type=style&index=0&id=24c5bd54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c5bd54",
  null
  
)

export default component.exports